import type { SerializableNode, TContentGatePopupElement } from '@shared/dream-components';
import type { WritableDraft } from 'immer';
import { produce } from 'immer';

export type ProcessorFunctionOptions = {
  publicationUrl?: string;
};

export type ProcessorFunction = (node: WritableDraft<SerializableNode>, options?: ProcessorFunctionOptions) => void;

export const processContentGatePopupNode = (node: TContentGatePopupElement, options?: ProcessorFunctionOptions) => {
  if (!options?.publicationUrl || !Array.isArray(node.content) || node.content.length === 0) {
    return node;
  }

  const replaceableURLS = ['http://the-way-of-all-flesh.localhiiv.com:3002/'];

  node.content = produce(node.content, (contentDraft: SerializableNode) => {
    try {
      let json = JSON.stringify(contentDraft);
      replaceableURLS.forEach((url) => {
        json = json.replaceAll(url, options?.publicationUrl as string);
      });
      return JSON.parse(json);
    } catch {
      return contentDraft;
    }
  });

  return node;
};

export const processors = {
  processContentGatePopupNode,
};
